import appConstants from '@/config/appConstants';
import Cookies from 'js-cookie';

const readArtifact = (cookieKey, fallback) => {
  try {
    const fromCookie = Cookies.get(cookieKey);
    if (fromCookie) return fromCookie;
  } catch (e) {
    /* nothing */
  }
  return fallback;
};

const extractAccessToken = (raw) => {
  if (!raw) return raw;
  if (typeof raw !== 'string') return raw;
  const trimmed = raw.trim();
  if (!trimmed.startsWith('{')) return trimmed;
  try {
    const parsed = JSON.parse(trimmed);
    return parsed.access_token || trimmed;
  } catch (e) {
    return trimmed;
  }
};

export const getAuthToken = () => extractAccessToken(readArtifact('_au', null));

export const getOrgId = () => readArtifact('_co', null);

export const getExzeoId = () => readArtifact('exzeoid', null);

export const getAuthHeaders = (contentType = appConstants.contenType.json) => ({
  'Authorization': `Bearer ${getAuthToken()}`,
  'org-id': getOrgId(),
  'x-xzo-source': 'web',
  "cache-control": "no-cache",
  "pragma": "no-cache",
});
